class FuncUtil {
  
  static isFunction(func){
    return Object.prototype.toString.call(func) === "[object Function]";
  }

  //获取函数名
  static getFnName(func){
    if(!this.isFunction(func)){
      return;
    }
    return func.name || func.toString().match(/function\s*([^(]*)\(/)[1];
  }

  //是否是async函数
  static isAsyncFunction(func){
    if(Object.prototype.toString.call(func) == '[Object AsyncFunction]'){
      return true;
    }
    return false;
  }

  //获取参数名称
  static getArgs(func) {
    // 先用正则匹配,取得符合参数模式的字符串.
    // 第一个分组是这个: ([^)]*) 非右括号的任意字符
    var args = func.toString().match(/function\s.*?\(([^)]*)\)/)[1];
    // 用逗号来分隔参数(arguments string).
    return args.split(",").map(function(arg) {
     // 去除注释(inline comments)以及空格
     return arg.replace(/\/\*.*\*\//, "").trim();
    }).filter(function(arg) {
     // 确保没有 undefined.
     return arg;
    });
   }
}
export default FuncUtil;
